import {jsx as _jsx} from "react/jsx-runtime";
import * as DropdownMenu from '@radix-ui/react-dropdown-menu'
import * as React from 'react'
import {cn} from '../cn'






export const MenuContent = React.forwardRef(
  ({className, children, ...props}, ref) => {
    return (
      _jsx(DropdownMenu.Content, {
        className: cn(
          'z-10 max-h-56 w-auto min-w-[200px] max-w-[400px] overflow-auto rounded-md bg-white py-1 shadow-lg outline-hidden data-[side=bottom]:animate-slide-down data-[side=top]:animate-slide-up',
          className
        ),
        ref: ref,
        ...props,
 children: 
        children
      })
    )
  }
)
